import { render } from "./SupplierView.vue?vue&type=template&id=6815f932&ts=true"
import script from "./SupplierView.vue?vue&type=script&lang=ts"
export * from "./SupplierView.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__